export const LOGIN_SUCCESS = "LOGIN_SUCESS";
export const LOGIN_FAILED = "LOGIN_FAILED";
export const AUTH_REQUEST_START = "AUTH_REQUEST_START";
export const AUTH_REQUEST_END = "AUTH_REQUEST_END";
export const LOG_OUT = "LOG_OUT";
export const LOG_OUT_SUCCESS = "LOG_OUT_SUCCESS";
export const FETCH_BALANCE_SUCCESS = "FETCH_BALANCE_SUCCESS";
export const FETCH_BALANCE_FAILED = "FETCH_BALANCE_FAILED";
export const MAIL_VERIFIED_REQUEST_SUCCESS = "MAIL_VERIFIED_REQUEST_SUCCESS";
export const MAIL_VERIFIED_REQUEST_FAILED = "MAIL_VERIFIED_REQUEST_FAILED";

export const SET_JWT_TOKEN = "SET_JWT_TOKEN";
export const SET_SAP_TOKEN = "SET_SAP_TOKEN";
export const SET_OPERATOR_ID = "SET_OPERATOR_ID";
export const SET_PARTNER_ID = "SET_PARTNER_ID";
export const SET_PROVIDER_ID = "SET_PROVIDER_ID";
export const SET_GRID_VIEW = "SET_GRID_VIEW";
export const SET_LOADER_SUCCESS = "SET_LOADER_SUCCESS";
export const SET_LOBBY_TYPE = "SET_LOBBY_TYPE";
